import { FRACTIONS_PER_CURRENCY } from '@/utils/consts';

import { GetDemoNegotiationMetricsResponse } from './getDemoNegotiationsMetricsResponseStruct';

export const parseGetDemoNegotiationsMetricsResponse = ({
  data: { id, attributes },
}: GetDemoNegotiationMetricsResponse) => {
  return {
    id,
    ...attributes,
    currentSpend: attributes.currentSpend / FRACTIONS_PER_CURRENCY,
    potentialSavings: attributes.potentialSavings / FRACTIONS_PER_CURRENCY,
    potentialCostAvoidance:
      attributes.potentialCostAvoidance / FRACTIONS_PER_CURRENCY,
  };
};

export type DemoNegotiationMetrics = Omit<
  ReturnType<typeof parseGetDemoNegotiationsMetricsResponse>,
  'id'
>;
